<template>
<div class="chapter">
<div class="inner_page">
<div class="basic-text-frame" id="_idContainer055">
<p class="normal"> </p>
<p class="structure-tt">Postcards to the Universe</p>
<p class="normal"> </p>
<p class="normal"> </p>
<p class="normal1"><span class="charoverride">Harness the Universe’s Power and Manifest Your Dreams</span></p>
<p class="normal1"><span class="charoverride1">Melisa Caprio<br class="calibre2"/> </span></p>
<p class="normal"> </p>
<p class="normal1"><span class="charoverride2"><img alt="" class="_idgenobjectattribute" src="OEBPS/image/2.png"/></span></p>
<p class="body-text">Coral Gables</p>
<p class="normal"><span class="charoverride3"> </span></p>
<div class="calibre1" id="calibre_pb_4"></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ebook_split_003.vue?5848778a